'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'face-smile';
var width = 512;
var height = 512;
var aliases = [128578,"smile"];
var unicode = 'f118';
var svgPathData = 'M496 256a240 240 0 1 0 -480 0 240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM256 384c45.3 0 85.4-22.1 110.1-56.1l12.9 9.4c-27.6 38-72.4 62.7-123 62.7s-95.4-24.7-123-62.7l12.9-9.4c24.7 34 64.8 56.1 110.1 56.1zM160 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceSmile = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;